export default __webpack_public_path__ + "static/flag-ee-28ae63b86ec7ad4bd19c56b9ca2464a1.svg";